// extracted by mini-css-extract-plugin
export default {"paper":"AuthPages_paper__58a+B","fade-in-from-top":"AuthPages_fade-in-from-top__1HEIw","waves":"AuthPages_waves__Aa1M0","move-forever":"AuthPages_move-forever__hpY4g"};